import React, { useState, useEffect, useRef } from 'react';
import { FaSearch } from 'react-icons/fa';
import { useLang } from '../context/LangContext';

function SearchBar({ onSearch, totalCount, searchRef }) {
  const { t } = useLang();
  const [query, setQuery] = useState('');
  const inputRef = useRef(null);

  // Expose focus via ref
  useEffect(() => {
    if (searchRef) {
      searchRef.current = {
        focus: () => inputRef.current?.focus()
      };
    }
  }, [searchRef]);

  // Keyboard shortcut ⌘+K
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        inputRef.current?.focus();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(query);
  };

  const handleChange = (e) => {
    setQuery(e.target.value);
    if (e.target.value === '') {
      onSearch('');
    }
  };

  return (
    <div className="hero-search">
      <form onSubmit={handleSubmit} className="hero-search-form">
        <div className="hero-search-wrapper">
          <input
            ref={inputRef}
            type="text"
            placeholder={t('searchPlaceholder')}
            value={query}
            onChange={handleChange}
            className="hero-search-input"
          />
          <span className="hero-search-kbd">⌘ + K</span>
          <button type="submit" className="hero-search-btn">
            <FaSearch />
          </button>
        </div>
      </form>
    </div>
  );
}

export default SearchBar;
